/**
 * @module mOffice
 * @description mOffice application procides user interface for back-office users
 */

const COMPILED_LANGUAGES = 'en,sk'
const PREFERRED_COUNTRIES = 'SK,CZ,AT,HU,PL,DE,CH,UA,RO,MD,BG,RS,HR,SI'
require('../mele_elements')
const mfs = require('msysFS')

function beforeStart(config) {
  require('./'+MOSY_APP+'.scss')
  require('../../../res/js/cars.js')
  require('msysGeo').loadGeoData(require('raw-loader!../../../res/geo/geo-slovakia-sample.txt'))

  const map_center = _.CONSTANTS.Soitron
  const start_module = 'mmodOfficeWfDashboard'
  const menu_modules = [
    { label: 'office.administration', disabled: true },
    'mmodOfficeWfUsers', 'mmodOfficeWfZones', 'mmodOfficeWfApplications', 'mmodOfficeWfConfigurations', 'mmodOfficeWfEnrollments', 'mmodOfficeWfDevices', 'mmodOfficeConnections', 'mmodOfficeAdmin',
    { label: 'office.operation', disabled: true },
    'mmodOfficeWfDashboard', 'mmodMap', 'mmodUnits', 'mmodOfficeFleet', 'mmodChats',
    'mmodOfficeInstructionsLive',
    'mmodOfficeIncidentsMine',
    'mmodOfficeIncidentsLive',
    'mmodOfficeAlprsLive',
    'mmodOfficeWfDopplers', 'mmodOfficeWfDopplerCalibrations',
    'mmodOfficeWfDelicts',
    'mmodOfficeWiki',
    { label: 'office.blacklists', disabled: true },
    'mmodOfficeWantedVehicles', 'mmodOfficeWantedPersons',
    { label: 'office.registers', disabled: true },
    'mmodOfficeDelictTypes',
    'mmodOfficeTowns', 'mmodOfficeStreets',
    'mmodOfficeVehicles', 'mmodOfficePersons', 'mmodOfficeDocuments',
    { label: 'office.reports', disabled: true },
    'mmodOfficeInstructions',
    'mmodOfficeIncidents',
    'mmodOfficeAlprs',
    'mmodOfficeFines',
  ]

  if(mfs.platform()==='nwjs') {
    const os = mfs.os()
    const mServer_paths = os === 'win' ? ['$app/mServer.exe'] : os === 'mac' ? ['$app/../../../../../../../../../../../../../build/BASE/mServer/mServer-mac'] : []
    let mServer_path = null
    for(const p of mServer_paths) {
      if(mfs.existsFile(p)) {
        mServer_path = p
        break
      }
    }
    if(mServer_path) {
      if(!config) config = {}
      if(!config.mmodEnroll) config.mmodEnroll = {}
      config.mmodEnroll.auto_enroll = true
      config.mmodEnroll.server = 'ws://localhost:8000'
      start_mServer(mServer_path)
    }
  }

  _.defaultsDeep(config, {
    mele_map: {
      center: map_center,
    },
    msysUser: {
      users_server: ':msvrUsers',
      zones_server: ':msvrZones',
      // auto_login: "master",
      // auto_password: "m",
      // auto_callsign: "MAJSTER"
    },
    msysWM: {
      lang: 'en',
      behavior: 'desktop',
      theme: 'day',
      styleset: 'new',
      start: start_module,
      fullscreen: false,
    },
    mmodAppBar: {
      modules: menu_modules,
      module_on_login: start_module,
      desktop: { type: 'dock', side: 'left', width: 200, order: 2 },
      languages: COMPILED_LANGUAGES.split(','),
    },
    mmodQuickBar: {
      init: { type: 'dock', side: 'top', height: 42, order: 3 },
      languages: COMPILED_LANGUAGES.split(','),
    },
    mmodAppWall: {
      modules: menu_modules,
    },
    mmodMap: {
      center: map_center,
    },
    mmodUnits: {
      streaming: true,
    },
    mmodOfficeFleet: {
      streaming: true,
    },
    msysProxy: {
      repos: {
        wiki: { fallbacks: [':'] },
        map_data: { fallbacks: [':'] },
        map_day: { fallbacks: ['https://tile.openstreetmap.org/{pathnoext}.png'], cache: false },
        map_night: { fallbacks: ['https://a.basemaps.cartocdn.com/dark_all/{pathnoext}.png'], cache: false },
      },
    },
  })
} // beforeStart

const LISTENERS = [
  // CORE SYSTEM
  require('msysLogger'),
  require('msysExec'),

  // CORE GUI
  require('msysWM'),
  require('mmodEmpty'),
  require('mmodSplash'),
  require('mmodAppBar'),
  require('mmodAppWall'),
  require('mmodAppLogo'),
  require('mmodQuickBar'),
  require('mmodNotifications'),
  require('mmodOfficeImport'),

  // CLIENT/SERVER
  require('msysProxy'),
  require('msysDomainClient'),
  require('mmodEnroll'),
  require('msysUser'),
  require('mmodLogin'),

  // ADMINISTRATION
  [require('mmodWorkflow'), 'mmodOfficeWfUsers', { workflow_server: ':msvrUsers', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfZones', { workflow_server: ':msvrZones', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWfApplications', { workflow_server: ':msvrApplications', tabular: true }],
  require('mmodOfficeWfConfigurations'),
  [require('mmodWorkflow'), 'mmodOfficeWfEnrollments', { workflow_server: ':msvrEnrollments', tabular: true }],
  require('mmodOfficeWfDevices'),
  require('mmodOfficeConnections'),
  require('mmodOfficeAdmin'),

  // OPERATIONAL
  require('mmodOfficeWfDashboard'),
  require('mmodMap'),
  require('mmodUnits'),
  require('mmodPlayer'),
  require('mmodOfficeFleet'),
  require('mmodChats'),
  [require('mmodWorkflow'), 'mmodOfficeInstructionsLive', { workflow_server: ':msvrWfInstructions', tabular: true, list_view: 'livetable' }],
  [require('mmodWorkflow'), 'mmodOfficeIncidentsMine', { workflow_server: ':msvrWfIncidents', tabular: true, list_view: 'minetable' }],
  [require('mmodWorkflow'), 'mmodOfficeIncidentsLive', { workflow_server: ':msvrWfIncidents', tabular: true, list_view: 'livetable' }],
  [require('mmodWorkflow'), 'mmodOfficeAlprsLive', { workflow_server: ':msvrWfAlpr', tabular: true, list_view: 'livetable', filter_view: 'livefilter' }],
  [require('mmodWorkflow'), 'mmodOfficeScreeningsLive', { workflow_server: ':msvrWfScreenings', tabular: true, list_view: 'livetable', filter_view: 'livefilter' }],
  [require('mmodWorkflow'), 'mmodOfficeFinesLive', { workflow_server: ':msvrWfFines', tabular: true, list_view: 'livetable' }],
  [require('mmodWorkflow'), 'mmodOfficeWiki', { workflow_server: ':msvrWfWiki' }],
  require('mmodOfficeWfDopplers'),
  require('mmodOfficeWfDopplerCalibrations'),
  require('mmodOfficeWfDelicts'),
  [require('mmodWorkflow'), 'mmodOfficeDelictTypes', { workflow_server: ':msvrWfDelictTypes', tabular: true }],

  // REGISTERS
  [require('mmodWorkflow'), 'mmodOfficeTowns', { workflow_server: ':msvrWfTowns', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeStreets', { workflow_server: ':msvrWfStreets', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficePersons', { workflow_server: ':msvrWfPersons', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeVehicles', { workflow_server: ':msvrWfVehicles', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeDocuments', { workflow_server: ':msvrWfDocuments', tabular: true }],

  // BLACKLISTS
  [require('mmodWorkflow'), 'mmodOfficeWantedVehicles', { workflow_server: ':msvrWfWantedVehicles', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeWantedPersons', { workflow_server: ':msvrWfWantedPersons', tabular: true }],

  // REPORTING
  [require('mmodWorkflow'), 'mmodOfficeInstructions', { workflow_server: ':msvrWfInstructions', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeIncidents', { workflow_server: ':msvrWfIncidents', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeAlprs', { workflow_server: ':msvrWfAlpr', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeScreenings', { workflow_server: ':msvrWfScreenings', tabular: true }],
  [require('mmodWorkflow'), 'mmodOfficeFines', { workflow_server: ':msvrWfFines', tabular: true }],
] // LISTENERS

function start_mServer(mServer_path) {
  let starting = false
  if(!nw.global.mServer) {
    const server_exe = mfs.fullpath(mServer_path)
    nw.global.mServer = require('child_process').spawn(server_exe)
    starting = true
    console.info('Starting mServer: '+mServer_path)
  }

  const p = nw.global.mServer

  let stdout = ''
  p.stdout.on('data', chunk=>{
    console.debug('mServer-stdout> '+chunk)
    stdout += chunk
    if(starting) {
      if(/system: STARTED APPLICATION/.test(stdout)) {
        starting = false
        console.info('mServer started')
      }
    }
  })
  p.stderr.on('data', chunk=>{
    console.debug('mServer-stderr> '+chunk)
  })
  p.on('error', (err)=>{
    console.error('mServer-error> '+err)
  })
  p.on('close', (code)=>{
    console.error('mServer exited: '+code)
    alert(LANG.translate(COMPILED_LANGUAGES.split(',')[0], 'exec_mserver_failed'))
  })
} // start_mServer

require('msysApplication')(LISTENERS, beforeStart)
